import {
  HttpBackend,
  HttpClient,
  HttpErrorResponse,
  HttpEvent,
  HttpEventType,
  HttpHeaders,
  HttpParams,
} from '@angular/common/http';
import { Injectable, signal } from '@angular/core';
import { Observable, Subject, throwError } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root',
})
export class RegistreService {
  serverUrl = environment.serverUrl;
  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
  };

  //private http: HttpClient;
  private static cacheBuster$: Subject<void> = new Subject<void>();
  constructor(
    handler: HttpBackend,
    private http: HttpClient,
    public authService: AuthService
  ) {
    //this.http = new HttpClient(handler);
  }

  archive_apscan_multiple_entries(data: any) {
    return this.http
      .post<any>(
        this.serverUrl + 'registre/archive_apscan_multiple_entries', data,
        this.httpOptions
      )
      .pipe(catchError(this.handleError));
  }

  archive_apscan_single_entries(entryid: string) {
    return this.http
      .post<any>(
        this.serverUrl + 'registre/archive_apscan_single_entries/' + entryid, {},
        this.httpOptions
      )
      .pipe(catchError(this.handleError));
  }

  download_apscan_pdf_report(entryid: string) {
    return this.http
      .get(this.serverUrl + 'registre/download_apscan_pdf_report/' + entryid, {
        responseType: 'blob',
        observe: 'response',
      })
      .pipe(catchError(this.handleError));
  }

  delete_apscan_entries(entryid: string) {
    return this.http
      .post<any>(
        this.serverUrl + 'registre/delete_apscan_entries/' + entryid, {},
        this.httpOptions
      )
      .pipe(catchError(this.handleError));
  }

  remove_investor_from_tranche(request: any) {
    return this.http
      .post<any>(
        this.serverUrl + 'registre/remove_investor_from_tranche',
        request,
        this.httpOptions
      )
      .pipe(catchError(this.handleError));
  }

  //@CacheBuster({ cacheBusterNotifier: RegistreService.cacheBuster$ })
  add_tx_payment_control_details(
    paymentcontroldetailpost: any
  ) {
    return this.http
      .post<any>(
        this.serverUrl + 'registre/add_tx_payment_control_details',
        paymentcontroldetailpost,
        this.httpOptions
      )
      .pipe(catchError(this.handleError));
  }
  //@CacheBuster({ cacheBusterNotifier: RegistreService.cacheBuster$ })
  add_registre_bearer(registrepost: any) {
    return this.http
      .post<any>(
        this.serverUrl + 'registre/add_registre_bearer',
        registrepost,
        this.httpOptions
      )
      .pipe(catchError(this.handleError));
  }
  //@CacheBuster({ cacheBusterNotifier: RegistreService.cacheBuster$ })
  check_lender_denomination(denomination: string) {
    return this.http
      .post<any>(
        this.serverUrl + 'registre/check_lender_denomination',
        { denomination: denomination },
        this.httpOptions
      )
      .pipe(catchError(this.handleError));
  }

  /**
   * Active lenders whose denomination looks like the one being typed (>= 70 % similarity).
   * Each match is a full lender row plus a `similarity` percentage, best first.
   * @param denomination The name being typed
   * @param currentSlug The lender being edited, excluded from the matches (optional)
   */
  find_similar_lender_denominations(denomination: string, currentSlug?: string) {
    return this.http
      .post<any>(
        this.serverUrl + 'registre/find_similar_lender_denominations',
        { denomination: denomination, current_slug: currentSlug },
        this.httpOptions
      )
      .pipe(catchError(this.handleError));
  }

  check_contact_name(request: any) {
    return this.http
      .post<any>(
        this.serverUrl + 'registre/check_contact_name',
        request,
        this.httpOptions
      )
      .pipe(catchError(this.handleError));
  }

  /**
   * Vérifie la validité et l'unicité d'un LEI
   * @param lei Le LEI à vérifier
   * @param currentSlug Le slug du lender actuel (pour l'édition, optionnel)
   * @returns Observable avec { valid, exists, message, existing_lender }
   */
  check_lei(lei: string, currentSlug?: string) {
    return this.http
      .post<any>(
        this.serverUrl + 'registre/check_lei',
        { lei: lei, current_slug: currentSlug },
        this.httpOptions
      )
      .pipe(catchError(this.handleError));
  }

  /**
   * Attaches a LEI to an existing lender that has none, so the register import can resolve its
   * rows by LEI whatever the spelling of the name on either side.
   *
   * @param slug Slug of the lender to complete
   * @param lei LEI carried by the register row
   * @returns Observable with { status, code, message, data }
   */
  attach_lei_to_lender(slug: string, lei: string) {
    return this.http
      .post<any>(
        this.serverUrl + 'registre/attach_lei_to_lender',
        { slug: slug, lei: lei },
        this.httpOptions
      )
      .pipe(catchError(this.handleError));
  }

  check_isin(isin: string, currentSlug?: string) {
    return this.http
      .post<any>(
        this.serverUrl + 'registre/check_isin',
        { isin: isin, current_slug: currentSlug },
        this.httpOptions
      )
      .pipe(catchError(this.handleError));
  }
  //@CacheBuster({ cacheBusterNotifier: RegistreService.cacheBuster$ })
  add_investor_to_tranche(linkregistrepost: any) {
    return this.http
      .post<any>(
        this.serverUrl + 'registre/add_investor_to_tranche',
        linkregistrepost,
        this.httpOptions
      )
      .pipe(catchError(this.handleError));
  }
  //@CacheBuster({ cacheBusterNotifier: RegistreService.cacheBuster$ })
  add_tracking_nominal_value(
    nominalvaluetrackingpost: any
  ) {
    return this.http
      .post<any>(
        this.serverUrl + 'registre/add_tracking_nominal_value',
        nominalvaluetrackingpost,
        this.httpOptions
      )
      .pipe(catchError(this.handleError));
  }
  //@CacheBuster({ cacheBusterNotifier: RegistreService.cacheBuster$ })
  add_tracking_number_of_units(
    numberofunitstrackingpost: any
  ) {
    return this.http
      .post<any>(
        this.serverUrl + 'registre/add_tracking_number_of_units',
        numberofunitstrackingpost,
        this.httpOptions
      )
      .pipe(catchError(this.handleError));
  }
  //@CacheBuster({ cacheBusterNotifier: RegistreService.cacheBuster$ })
  create_commitment_fee(linkregistrepost: any) {
    return this.http
      .post<any>(
        this.serverUrl + 'registre/create_commitment_fee',
        linkregistrepost,
        this.httpOptions
      )
      .pipe(catchError(this.handleError));
  }
  //@CacheBuster({ cacheBusterNotifier: RegistreService.cacheBuster$ })
  add_thirdpartiesfees_for_drawdown(
    closingphirdpartiesfeespost: any
  ) {
    return this.http
      .post<any>(
        this.serverUrl + 'registre/add_thirdpartiesfees_for_drawdown',
        closingphirdpartiesfeespost,
        this.httpOptions
      )
      .pipe(catchError(this.handleError));
  }

  //@CacheBuster({ cacheBusterNotifier: RegistreService.cacheBuster$ })
  add_commitment_fee_details(linkregistrepost: any) {
    return this.http
      .post<any>(
        this.serverUrl + 'registre/add_commitment_fee_details',
        linkregistrepost,
        this.httpOptions
      )
      .pipe(catchError(this.handleError));
  }

  //@CacheBuster({ cacheBusterNotifier: RegistreService.cacheBuster$ })
  set_rib_kyc_validation_lender_backoffice(
    kycvalidationpost: any
  ) {
    return this.http
      .post<any>(
        this.serverUrl + 'registre/set_rib_kyc_validation_lender_backoffice',
        kycvalidationpost,
        this.httpOptions
      )
      .pipe(catchError(this.handleError));
  }

  //@Cacheable({ cacheBusterObserver: RegistreService.cacheBuster$ })
  getinvaliditydocument() {
    return this.http
      .get<
        []
      >(this.serverUrl + 'registre/getinvaliditydocument', this.httpOptions)
      .pipe(catchError(this.handleError));
  }

  //@Cacheable({ cacheBusterObserver: RegistreService.cacheBuster$ })
  getregistrebytranche(slugtranche) {
    return this.http
      .get<
        []
      >(this.serverUrl + 'registre/getregistrebytranche/' + slugtranche, this.httpOptions)
      .pipe(catchError(this.handleError));
  }
  //@Cacheable({ cacheBusterObserver: RegistreService.cacheBuster$ })
  getlastidcalendarforpikorcash(type, tranche) {
    return this.http
      .get<any>(
        this.serverUrl +
        'local/getlastidcalendarforpikorcash/' +
        type +
        '/' +
        tranche,
        this.httpOptions
      )
      .pipe(catchError(this.handleError));
  }
  //@Cacheable({ cacheBusterObserver: RegistreService.cacheBuster$ })
  getEventGlobalCalendarByUser(sluguser, slugtranche) {
    return this.http
      .get<
        []
      >(this.serverUrl + 'registre/getEventGlobalCalendarByUser/' + sluguser + '/' + slugtranche, this.httpOptions)
      .pipe(catchError(this.handleError));
  }
  //@Cacheable({ cacheBusterObserver: RegistreService.cacheBuster$ })
  get_all_registre_bearer_by_corporate(slug) {
    return this.http
      .get<
        []
      >(this.serverUrl + 'registre/get_all_registre_bearer_by_corporate/' + slug, this.httpOptions)
      .pipe(catchError(this.handleError));
  }
  /**
   * Amounts invested by the lenders linked to a management company (source: register):
   * totals by currency + breakdown per lender and per deal.
   */
  get_total_invested_amount_by_corporate(slug: string) {
    return this.http
      .get<{
        total_invested_amount: number;
        currency: string;
        by_currency: { currency: string; amount: number }[];
        lenders_count: number;
        lenders: {
          slug_investor: string;
          denomination: string;
          deals: { slug_deal: string; deal_name: string; currency: string; amount: number }[];
        }[];
      }>(this.serverUrl + 'registre/get_total_invested_amount_by_corporate/' + slug, this.httpOptions)
      .pipe(catchError(this.handleError));
  }

  /**
   * Total amount invested by a single lender + breakdown per deal (source: register).
   */
  get_total_invested_amount_by_lender(slug: string) {
    return this.http
      .get<{
        total_invested_amount: number;
        currency: string;
        by_currency: { currency: string; amount: number }[];
        deals: { slug_deal: string; deal_name: string; currency: string; amount: number }[];
      }>(this.serverUrl + 'registre/get_total_invested_amount_by_lender/' + slug, this.httpOptions)
      .pipe(catchError(this.handleError));
  }

  //@Cacheable({ cacheBusterObserver: RegistreService.cacheBuster$ })
  get_all_registre_bearer() {
    return this.http
      .get<
        []
      >(this.serverUrl + 'registre/get_all_registre_bearer', this.httpOptions)
      .pipe(catchError(this.handleError));
  }

  //@Cacheable({ cacheBusterObserver: RegistreService.cacheBuster$ })
  get_all_bearer_by_operation_by_deal_and_tranche(deal, tranche) {
    return this.http
      .get<
        any
      >(this.serverUrl + 'registre/get_all_bearer_by_operation_by_deal_and_tranche/' + deal + '/' + tranche, this.httpOptions)
      .pipe(catchError(this.handleError));
  }
  //@Cacheable({ cacheBusterObserver: RegistreService.cacheBuster$ })
  get_registre_by_deal_for_all_tranches(deal) {
    return this.http
      .get<
        []
      >(this.serverUrl + 'registre/get_registre_by_deal_for_all_tranches/' + deal, this.httpOptions)
      .pipe(catchError(this.handleError));
  }
  //@Cacheable({ cacheBusterObserver: RegistreService.cacheBuster$ })
  get_tranche_principal_info(deal, tranche = 'all') {
    return this.http
      .get<
        []
      >(this.serverUrl + 'registre/get_tranche_principal_info/' + deal + '/' + tranche, this.httpOptions)
      .pipe(catchError(this.handleError));
  }
  //@Cacheable({ cacheBusterObserver: RegistreService.cacheBuster$ })
  get_registre_overview_by_tranche_deal(deal, tranche, date) {
    return this.http
      .get<
        []
      >(this.serverUrl + 'registre/get_registre_overview_by_tranche_deal/' + deal + '/' + tranche + '/' + date, this.httpOptions)
      .pipe(catchError(this.handleError));
  }

  //@Cacheable({ cacheBusterObserver: RegistreService.cacheBuster$ })
  get_investor_overview_list_of_deal(investor) {
    return this.http
      .get<
        []
      >(this.serverUrl + 'registre/get_investor_overview_list_of_deal/' + investor, this.httpOptions)
      .pipe(catchError(this.handleError));
  }

  //@Cacheable({ cacheBusterObserver: RegistreService.cacheBuster$ })
  get_investor_detail(company, investor) {
    return this.http
      .get<
        []
      >(this.serverUrl + 'registre/get_investor_detail/' + company + '/' + investor, this.httpOptions)
      .pipe(catchError(this.handleError));
  }

  //@Cacheable({ cacheBusterObserver: RegistreService.cacheBuster$ })
  get_investor_synopsis_by_tranche_deal(deal, tranche, date, investor) {
    return this.http
      .get<
        []
      >(this.serverUrl + 'registre/get_investor_synopsis_by_tranche_deal/' + deal + '/' + tranche + '/' + date + '/' + investor, this.httpOptions)
      .pipe(catchError(this.handleError));
  }
  //@Cacheable({ cacheBusterObserver: RegistreService.cacheBuster$ })
  get_tranche_principal_info_byuser(deal, tranche, investor, date) {
    return this.http
      .get<
        []
      >(this.serverUrl + 'registre/get_tranche_principal_info_byuser/' + deal + '/' + tranche + '/' + investor + '/' + date, this.httpOptions)
      .pipe(catchError(this.handleError));
  }
  //@Cacheable({ cacheBusterObserver: RegistreService.cacheBuster$ })
  get_all_investor_drawdown_by_deal_and_tranche(deal, tranche) {
    return this.http
      .get<
        []
      >(this.serverUrl + 'registre/get_all_investor_drawdown_by_deal_and_tranche/' + deal + '/' + tranche, this.httpOptions)
      .pipe(catchError(this.handleError));
  }
  //@Cacheable({ cacheBusterObserver: RegistreService.cacheBuster$ })
  getdrawdown(deal, tranche) {
    return this.http
      .get<
        []
      >(this.serverUrl + 'registre/getdrawdown/' + deal + '/' + tranche, this.httpOptions)
      .pipe(catchError(this.handleError));
  }

  get_all_investor_closing_resume_by_deal_and_tranche(deal, tranche) {
    return this.http
      .get<
        []
      >(this.serverUrl + 'registre/get_all_investor_closing_resume_by_deal_and_tranche/' + deal + '/' + tranche, this.httpOptions)
      .pipe(catchError(this.handleError));
  }
  //@Cacheable({ cacheBusterObserver: RegistreService.cacheBuster$ })
  get_all_thirdpartiesfees(deal) {
    return this.http
      .get<
        []
      >(this.serverUrl + 'registre/get_all_thirdpartiesfees/' + deal, this.httpOptions)
      .pipe(catchError(this.handleError));
  }
  //@Cacheable({ cacheBusterObserver: RegistreService.cacheBuster$ })
  get_drawdown_detail(deal) {
    return this.http
      .get<
        []
      >(this.serverUrl + 'registre/get_drawdown_detail/' + deal, this.httpOptions)
      .pipe(catchError(this.handleError));
  }
  //@Cacheable({ cacheBusterObserver: RegistreService.cacheBuster$ })
  get_all_total_commitment_by_deal_tranche(deal, tranche) {
    return this.http
      .get<
        []
      >(this.serverUrl + 'registre/get_all_total_commitment_by_deal_tranche/' + deal + '/' + tranche, this.httpOptions)
      .pipe(catchError(this.handleError));
  }
  //@Cacheable({ cacheBusterObserver: RegistreService.cacheBuster$ })
  get_all_total_undrawn_by_deal_tranche(deal, tranche) {
    return this.http
      .get<
        []
      >(this.serverUrl + 'registre/get_all_total_undrawn_by_deal_tranche/' + deal + '/' + tranche, this.httpOptions)
      .pipe(catchError(this.handleError));
  }
  //@Cacheable({ cacheBusterObserver: RegistreService.cacheBuster$ })
  get_all_investor_bank_account(investor) {
    return this.http
      .get<
        []
      >(this.serverUrl + 'registre/get_all_investor_bank_account/' + investor, this.httpOptions)
      .pipe(catchError(this.handleError));
  }
  //@Cacheable({ cacheBusterObserver: RegistreService.cacheBuster$ })
  get_all_company_bank_account(investor) {
    return this.http
      .get<
        []
      >(this.serverUrl + 'payment_bank_account/wire_list/' + investor, this.httpOptions)
      .pipe(catchError(this.handleError));
  }

  get_corporate_bank_details(corporateRef: string) {
    return this.http
      .get<{
        corporate_slug: string;
        wire_accounts: any[];
        payment_hub_accounts: any[];
      }>(this.serverUrl + 'payment_bank_account/corporate/' + corporateRef, this.httpOptions)
      .pipe(catchError(this.handleError));
  }

  //@Cacheable({ cacheBusterObserver: RegistreService.cacheBuster$ })
  get_all_deal_bank_account(deal) {
    return this.http
      .get<
        []
      >(this.serverUrl + 'registre/get_all_deal_bank_account/' + deal, this.httpOptions)
      .pipe(catchError(this.handleError));
  }

  //@Cacheable({ cacheBusterObserver: RegistreService.cacheBuster$ })
  get_all_total_drawdown_by_deal_tranche(deal, tranche) {
    return this.http
      .get<
        []
      >(this.serverUrl + 'registre/get_all_total_drawdown_by_deal_tranche/' + deal + '/' + tranche, this.httpOptions)
      .pipe(catchError(this.handleError));
  }
  //@Cacheable({ cacheBusterObserver: RegistreService.cacheBuster$ })
  getdrawdowninfo(drawdown) {
    return this.http
      .get<
        []
      >(this.serverUrl + 'registre/getdrawdowninfo/' + drawdown, this.httpOptions)
      .pipe(catchError(this.handleError));
  }
  //@Cacheable({ cacheBusterObserver: RegistreService.cacheBuster$ })
  getpaymentinfo(drawdown) {
    return this.http
      .get<
        []
      >(this.serverUrl + 'registre/getpaymentinfo/' + drawdown, this.httpOptions)
      .pipe(catchError(this.handleError));
  }
  //@Cacheable({ cacheBusterObserver: RegistreService.cacheBuster$ })
  getcommitmentfeesinfo(drawdown) {
    return this.http
      .get<
        []
      >(this.serverUrl + 'registre/getcommitmentfeesinfo/' + drawdown, this.httpOptions)
      .pipe(catchError(this.handleError));
  }
  //@Cacheable({ cacheBusterObserver: RegistreService.cacheBuster$ })
  getpaymentinfotoggle(drawdown) {
    return this.http
      .get<
        []
      >(this.serverUrl + 'registre/getpaymentinfotoggle/' + drawdown, this.httpOptions)
      .pipe(catchError(this.handleError));
  }
  //@Cacheable({ cacheBusterObserver: RegistreService.cacheBuster$ })
  get_all_transaction_principal_by_deal_and_tranche(deal, tranche) {
    return this.http
      .get<
        []
      >(this.serverUrl + 'registre/get_all_transaction_principal_by_deal_and_tranche/' + deal + '/' + tranche, this.httpOptions)
      .pipe(catchError(this.handleError));
  }
  //@Cacheable({ cacheBusterObserver: RegistreService.cacheBuster$ })
  get_all_payment_by_deal_and_tranche(deal, tranche) {
    return this.http
      .get<
        []
      >(this.serverUrl + 'registre/get_all_payment_by_deal_and_tranche/' + deal + '/' + tranche, this.httpOptions)
      .pipe(catchError(this.handleError));
  }
  //@Cacheable({ cacheBusterObserver: RegistreService.cacheBuster$ })
  get_all_commitmentfees_by_deal_and_tranche(deal, tranche) {
    return this.http
      .get<
        []
      >(this.serverUrl + 'registre/get_all_commitmentfees_by_deal_and_tranche/' + deal + '/' + tranche, this.httpOptions)
      .pipe(catchError(this.handleError));
  }
  //@Cacheable({ cacheBusterObserver: RegistreService.cacheBuster$ })
  get_apscan_access_by_slug(slug) {
    return this.http
      .get<
        []
      >(this.serverUrl + 'registre/get_apscan_access_by_slug/' + slug, this.httpOptions)
      .pipe(catchError(this.handleError));
  }

  //@CacheBuster({ cacheBusterNotifier: RegistreService.cacheBuster$ })
  deletebankdetailcompany(id) {
    return this.http
      .post<any>(
        this.serverUrl + 'payment_bank_account/wire_delete/' + id,
        {},
        this.httpOptions
      )
      .pipe(catchError(this.handleError));
  }
  //@CacheBuster({ cacheBusterNotifier: RegistreService.cacheBuster$ })
  delete_lot_notice(id) {
    return this.http
      .post<any>(
        this.serverUrl + 'registre/delete_lot_notice/' + id,
        this.httpOptions
      )
      .pipe(catchError(this.handleError));
  }
  //@CacheBuster({ cacheBusterNotifier: RegistreService.cacheBuster$ })
  deletebankdetaillender(id) {
    return this.http
      .post<any>(
        this.serverUrl + 'registre/deletebankdetaillender/' + id,
        this.httpOptions
      )
      .pipe(catchError(this.handleError));
  }
  //@CacheBuster({ cacheBusterNotifier: RegistreService.cacheBuster$ })
  delete_bearer(id) {
    return this.http
      .post<any>(
        this.serverUrl + 'registre/delete_bearer/' + id,
        this.httpOptions
      )
      .pipe(catchError(this.handleError));
  }
  //@CacheBuster({ cacheBusterNotifier: RegistreService.cacheBuster$ })
  deletetrade(id) {
    return this.http
      .post<any>(
        this.serverUrl + 'registre/deletetrade/' + id,
        this.httpOptions
      )
      .pipe(catchError(this.handleError));
  }
  //@CacheBuster({ cacheBusterNotifier: RegistreService.cacheBuster$ })
  set_cash_interest_calendar_to_validate(id, slug_payment) {
    return this.http
      .post<any>(
        this.serverUrl +
        'registre/set_cash_interest_calendar_to_validate/' +
        id +
        '/' +
        slug_payment,
        this.httpOptions
      )
      .pipe(catchError(this.handleError));
  }
  //@CacheBuster({ cacheBusterNotifier: RegistreService.cacheBuster$ })
  set_commitmentfees_calendar_to_validate(id, slug_payment) {
    return this.http
      .post<any>(
        this.serverUrl +
        'registre/set_commitmentfees_calendar_to_validate/' +
        id +
        '/' +
        slug_payment,
        this.httpOptions
      )
      .pipe(catchError(this.handleError));
  }
  //@CacheBuster({ cacheBusterNotifier: RegistreService.cacheBuster$ })
  set_pik_interest_calendar_to_validate(id, slug_payment) {
    return this.http
      .post<any>(
        this.serverUrl +
        'registre/set_pik_interest_calendar_to_validate/' +
        id +
        '/' +
        slug_payment,
        this.httpOptions
      )
      .pipe(catchError(this.handleError));
  }

  //@Cacheable({ cacheBusterObserver: RegistreService.cacheBuster$ })
  delete_tx_registre_investor_tranche(tranche, slugfinancialdata) {
    return this.http
      .get<any>(
        this.serverUrl +
        'registre/delete_tx_registre_investor_tranche/' +
        tranche +
        '/' +
        slugfinancialdata,
        this.httpOptions
      )
      .pipe(catchError(this.handleError));
  }
  //@Cacheable({ cacheBusterObserver: RegistreService.cacheBuster$ })
  checkifexistedrawdown(slugfinancialdata) {
    return this.http
      .get<any>(
        this.serverUrl + 'registre/checkifexistedrawdown/' + slugfinancialdata,
        this.httpOptions
      )
      .pipe(catchError(this.handleError));
  }

  //@CacheBuster({ cacheBusterNotifier: RegistreService.cacheBuster$ })
  add_registre_operation(operationpost: any) {
    return this.http
      .post<any>(
        this.serverUrl + 'registre/add_registre_operation',
        operationpost,
        this.httpOptions
      )
      .pipe(catchError(this.handleError));
  }

  //@CacheBuster({ cacheBusterNotifier: RegistreService.cacheBuster$ })
  add_new_investor_bank_account(
    investorbankdetailpost: any
  ) {
    return this.http
      .post<any>(
        this.serverUrl + 'registre/add_new_investor_bank_account',
        investorbankdetailpost,
        this.httpOptions
      )
      .pipe(catchError(this.handleError));
  }

  //@CacheBuster({ cacheBusterNotifier: RegistreService.cacheBuster$ })
  add_new_bank(bankdetailpost: any) {
    return this.http
      .post<any>(
        this.serverUrl + 'local/add_new_bank',
        bankdetailpost,
        this.httpOptions
      )
      .pipe(catchError(this.handleError));
  }

  //@CacheBuster({ cacheBusterNotifier: RegistreService.cacheBuster$ })
  add_new_company_bank_account(
    investorbankdetailpost: any
  ) {
    return this.http
      .post<any>(
        this.serverUrl + 'payment_bank_account/wire_create',
        investorbankdetailpost,
        this.httpOptions
      )
      .pipe(catchError(this.handleError));
  }

  //@CacheBuster({ cacheBusterNotifier: RegistreService.cacheBuster$ })
  add_new_deal_bank_account(dealbankdetailpost: any) {
    return this.http
      .post<any>(
        this.serverUrl + 'registre/add_new_deal_bank_account',
        dealbankdetailpost,
        this.httpOptions
      )
      .pipe(catchError(this.handleError));
  }

  //@CacheBuster({ cacheBusterNotifier: RegistreService.cacheBuster$ })
  update_deal_bank_account(slug: any, dealbankdetailpost: any) {
    return this.http
      .post<any>(
        this.serverUrl + 'registre/update_deal_bank_account/' + slug,
        dealbankdetailpost,
        this.httpOptions
      )
      .pipe(catchError(this.handleError));
  }

  //@Cacheable({ cacheBusterObserver: RegistreService.cacheBuster$ })
  apsolution_getreferenciel(slug) {
    return this.http
      .get<any>(
        this.serverUrl + 'registre/apsolution_getreferenciel/' + slug,
        this.httpOptions
      )
      .pipe(catchError(this.handleError));
  }
  //@CacheBuster({ cacheBusterNotifier: RegistreService.cacheBuster$ })
  apsolution_login(apconnectpost: any) {
    return this.http
      .post<any>(
        this.serverUrl + 'registre/apsolution_login',
        apconnectpost,
        this.httpOptions
      )
      .pipe(catchError(this.handleError));
  }
  //@CacheBuster({ cacheBusterNotifier: RegistreService.cacheBuster$ })
  apsolution_ondemand(apondemandpost: any) {
    return this.http
      .post<any>(
        this.serverUrl + 'registre/apsolution_ondemand',
        apondemandpost,
        this.httpOptions
      )
      .pipe(catchError(this.handleError));
  }
  //@CacheBuster({ cacheBusterNotifier: RegistreService.cacheBuster$ })
  apsolution_ondemand_corporate(apondemandpost: any) {
    return this.http
      .post<any>(
        this.serverUrl + 'registre/apsolution_ondemand_corporate',
        apondemandpost,
        this.httpOptions
      )
      .pipe(catchError(this.handleError));
  }
  //@CacheBuster({ cacheBusterNotifier: RegistreService.cacheBuster$ })
  apsolution_ondemand_lender(apondemandpost: any) {
    return this.http
      .post<any>(
        this.serverUrl + 'registre/apsolution_ondemand_lender',
        apondemandpost,
        this.httpOptions
      )
      .pipe(catchError(this.handleError));
  }
  //@CacheBuster({ cacheBusterNotifier: RegistreService.cacheBuster$ })
  apsolution_ondemand_for_investor(apondemandpost: any) {
    return this.http
      .post<any>(
        this.serverUrl + 'registre/apsolution_ondemand_for_investor',
        apondemandpost,
        this.httpOptions
      )
      .pipe(catchError(this.handleError));
  }
  //@CacheBuster({ cacheBusterNotifier: RegistreService.cacheBuster$ })
  apsolution_logout(slug) {
    return this.http
      .post<any>(
        this.serverUrl + 'registre/apsolution_logout/' + slug,
        this.httpOptions
      )
      .pipe(catchError(this.handleError));
  }
  //@CacheBuster({ cacheBusterNotifier: RegistreService.cacheBuster$ })
  create_new_transaction_principal(
    transactionprincipalpost: any
  ) {
    return this.http
      .post<any>(
        this.serverUrl + 'registre/create_new_transaction_principal',
        transactionprincipalpost,
        this.httpOptions
      )
      .pipe(catchError(this.handleError));
  }
  //@CacheBuster({ cacheBusterNotifier: RegistreService.cacheBuster$ })
  add_new_event_to_payment_calendar(
    transactionprincipalpost: any
  ) {
    return this.http
      .post<any>(
        this.serverUrl + 'registre/add_new_event_to_payment_calendar',
        transactionprincipalpost,
        this.httpOptions
      )
      .pipe(catchError(this.handleError));
  }
  //@CacheBuster({ cacheBusterNotifier: RegistreService.cacheBuster$ })
  create_new_registre_tracking_historique_investor_status_transaction(
    transactionprincipalpost: any
  ) {
    return this.http
      .post<any>(
        this.serverUrl +
        'registre/create_new_registre_tracking_historique_investor_status_transaction',
        transactionprincipalpost,
        this.httpOptions
      )
      .pipe(catchError(this.handleError));
  }

  //@Cacheable({ cacheBusterObserver: RegistreService.cacheBuster$ })
  get_all_legal_document_of_company(company) {
    return this.http
      .get<
        []
      >(this.serverUrl + 'registre/get_all_legal_document_of_company/' + company, this.httpOptions)
      .pipe(catchError(this.handleError));
  }

  /**
   * Download a KYC document stored in the internal GED (or on disk for legacy rows).
   * `relativeUrl` is the `url` carried by the `file` member of each document row.
   */
  downloadKycDocument(relativeUrl: string) {
    return this.http
      .get(`${this.serverUrl}${relativeUrl}`, { responseType: 'blob' })
      .pipe(catchError(this.handleError));
  }
  //@Cacheable({ cacheBusterObserver: RegistreService.cacheBuster$ })
  getallEventCalendarByTranche(deal, tranche) {
    return this.http
      .get<
        []
      >(this.serverUrl + 'local/getallEventCalendarByTranche/' + deal + '/' + tranche, this.httpOptions)
      .pipe(catchError(this.handleError));
  }
  //@Cacheable({ cacheBusterObserver: RegistreService.cacheBuster$ })
  getallEventCalendarByTrancheBeforeIdCalendar(deal, tranche, idcalendar) {
    return this.http
      .get<
        []
      >(this.serverUrl + 'local/getallEventCalendarByTrancheBeforeIdCalendar/' + deal + '/' + tranche + '/' + idcalendar, this.httpOptions)
      .pipe(catchError(this.handleError));
  }
  //@Cacheable({ cacheBusterObserver: RegistreService.cacheBuster$ })
  getallEventCalendarByTrancheBeforeIdCalendarForCommitmentFeesLimitFive(
    deal,
    tranche,
    idcalendar
  ) {
    return this.http
      .get<
        []
      >(this.serverUrl + 'local/getallEventCalendarByTrancheBeforeIdCalendarForCommitmentFeesLimitFive/' + deal + '/' + tranche + '/' + idcalendar, this.httpOptions)
      .pipe(catchError(this.handleError));
  }
  //@Cacheable({ cacheBusterObserver: RegistreService.cacheBuster$ })
  getallEventCalendarByTrancheBeforeIdCalendarLimitFive(
    deal,
    tranche,
    idcalendar
  ) {
    return this.http
      .get<
        []
      >(this.serverUrl + 'local/getallEventCalendarByTrancheBeforeIdCalendarLimitFive/' + deal + '/' + tranche + '/' + idcalendar, this.httpOptions)
      .pipe(catchError(this.handleError));
  }
  //@Cacheable({ cacheBusterObserver: RegistreService.cacheBuster$ })
  getallEventCalendarByTrancheBeforeIdCalendarPikLimitFive(
    deal,
    tranche,
    idcalendar
  ) {
    return this.http
      .get<
        []
      >(this.serverUrl + 'local/getallEventCalendarByTrancheBeforeIdCalendarPikLimitFive/' + deal + '/' + tranche + '/' + idcalendar, this.httpOptions)
      .pipe(catchError(this.handleError));
  }
  //@Cacheable({ cacheBusterObserver: RegistreService.cacheBuster$ })
  get_all_investor_legal_document_of_company(company) {
    return this.http
      .get<
        []
      >(this.serverUrl + 'registre/get_all_investor_legal_document_of_company/' + company, this.httpOptions)
      .pipe(catchError(this.handleError));
  }
  //@Cacheable({ cacheBusterObserver: RegistreService.cacheBuster$ })
  get_legal_document_of_company_by_id(id) {
    return this.http
      .get<
        []
      >(this.serverUrl + 'registre/get_legal_document_of_company_by_id/' + id, this.httpOptions)
      .pipe(catchError(this.handleError));
  }
  //@Cacheable({ cacheBusterObserver: RegistreService.cacheBuster$ })
  get_investor_legal_document_of_company_by_id(id) {
    return this.http
      .get<
        []
      >(this.serverUrl + 'registre/get_investor_legal_document_of_company_by_id/' + id, this.httpOptions)
      .pipe(catchError(this.handleError));
  }

  //@Cacheable({ cacheBusterObserver: RegistreService.cacheBuster$ })
  get_organization_contact_document_of_company_by_id(id) {
    return this.http
      .get<
        []
      >(this.serverUrl + 'registre/get_organization_contact_document_of_company_by_id/' + id, this.httpOptions)
      .pipe(catchError(this.handleError));
  }

  get_investor_organization_contact_document_of_company_by_slug(slug_investor, slug_contact) {
    return this.http
      .get<
        []
      >(this.serverUrl + 'registre/get_investor_organization_contact_document_of_company_by_slug/' + slug_investor + '/' + slug_contact, this.httpOptions)
      .pipe(catchError(this.handleError));
  }

  //@Cacheable({ cacheBusterObserver: RegistreService.cacheBuster$ })
  get_investor_organization_contact_document_of_company_by_id(id) {
    return this.http
      .get<
        []
      >(this.serverUrl + 'registre/get_investor_organization_contact_document_of_company_by_id/' + id, this.httpOptions)
      .pipe(catchError(this.handleError));
  }

  //@Cacheable({ cacheBusterObserver: RegistreService.cacheBuster$ })
  get_organization_document_of_company_by_id(id) {
    return this.http
      .get<
        []
      >(this.serverUrl + 'registre/get_organization_document_of_company_by_id/' + id, this.httpOptions)
      .pipe(catchError(this.handleError));
  }

  //@Cacheable({ cacheBusterObserver: RegistreService.cacheBuster$ })
  get_investor_organization_document_of_company_by_id(id) {
    return this.http
      .get<
        []
      >(this.serverUrl + 'registre/get_investor_organization_document_of_company_by_id/' + id, this.httpOptions)
      .pipe(catchError(this.handleError));
  }

  /**
   * Upload one document into a chosen folder of a KYC pack (Documents tab of the
   * KYC company / KYC lender screens).
   *
   * Separate endpoint from the four add_*_document_to_company above: those are
   * also called by the Corporate module, so their role gate cannot be tightened
   * to the KYC roles. This one is gated on them.
   *
   * FormData: scope, owner_slug, category, nature, issuance_date, validity_date,
   * folder_path, file.
   */
  upload_kyc_document_to_folder(formData: FormData) {
    return this.http
      .post<any>(this.serverUrl + "kyc_document/upload", formData)
      .pipe(catchError(this.handleError));
  }

  //@CacheBuster({ cacheBusterNotifier: RegistreService.cacheBuster$ })
  add_legal_document_to_company(formData) {
    return this.http
      .post<any>(
        this.serverUrl + 'registre/add_legal_document_to_company',
        formData,
        {
          reportProgress: true,
          observe: 'events',
        }
      )
      .pipe(
        map(event => this.getEventMessage(event, formData)),
        catchError(this.handleError)
      );
  }

  //@CacheBuster({ cacheBusterNotifier: RegistreService.cacheBuster$ })
  add_investor_legal_document_to_company(formData) {
    return this.http
      .post<any>(
        this.serverUrl + 'registre/add_investor_legal_document_to_company',
        formData,
        {
          //headers: { 'Content-Type': 'multipart/form-data'} ,
          reportProgress: true,
          observe: 'events',
        }
      )
      .pipe(
        map(event => this.getEventMessage(event, formData)),
        catchError(this.handleError)
      );
  }

  //@CacheBuster({ cacheBusterNotifier: RegistreService.cacheBuster$ })
  add_organization_document_to_company(formData) {
    return this.http
      .post<any>(
        this.serverUrl + 'registre/add_organization_document_to_company',
        formData,
        {
          reportProgress: true,
          observe: 'events',
        }
      )
      .pipe(
        map(event => this.getEventMessage(event, formData)),
        catchError(this.handleError)
      );
  }

  //@CacheBuster({ cacheBusterNotifier: RegistreService.cacheBuster$ })
  add_investor_organization_document_to_company(formData) {
    return this.http
      .post<any>(
        this.serverUrl +
        'registre/add_investor_organization_document_to_company',
        formData,
        {
          reportProgress: true,
          observe: 'events',
        }
      )
      .pipe(
        map(event => this.getEventMessage(event, formData)),
        catchError(this.handleError)
      );
  }

  //@CacheBuster({ cacheBusterNotifier: RegistreService.cacheBuster$ })
  add_organization_contact_document_to_company(formData) {
    return this.http
      .post<any>(
        this.serverUrl +
        'registre/add_organization_contact_document_to_company',
        formData,
        {
          reportProgress: true,
          observe: 'events',
        }
      )
      .pipe(
        map(event => this.getEventMessage(event, formData)),
        catchError(this.handleError)
      );
  }

  add_organization_contact_document_to_investor(formData) {
    return this.http
      .post<any>(
        this.serverUrl +
        'registre/add_organization_contact_document_to_investor',
        formData,
        {
          reportProgress: true,
          observe: 'events',
        }
      )
      .pipe(
        map(event => this.getEventMessage(event, formData)),
        catchError(this.handleError)
      );
  }

  //@CacheBuster({ cacheBusterNotifier: RegistreService.cacheBuster$ })
  add_investor_organization_contact_document_to_company(formData) {
    return this.http
      .post<any>(
        this.serverUrl +
        'registre/add_investor_organization_contact_document_to_company',
        formData,
        {
          reportProgress: true,
          observe: 'events',
        }
      )
      .pipe(
        map(event => this.getEventMessage(event, formData)),
        catchError(this.handleError)
      );
  }

  //@CacheBuster({ cacheBusterNotifier: RegistreService.cacheBuster$ })
  delete_legal_document_to_company(id) {
    return this.http
      .post<any>(
        this.serverUrl + 'registre/delete_legal_document_to_company/' + id,
        this.httpOptions
      )
      .pipe(catchError(this.handleError));
  }

  //@CacheBuster({ cacheBusterNotifier: RegistreService.cacheBuster$ })
  delete_investor_legal_document_to_company(id) {
    return this.http
      .post<any>(
        this.serverUrl +
        'registre/delete_investor_legal_document_to_company/' +
        id,
        this.httpOptions
      )
      .pipe(catchError(this.handleError));
  }
  //@CacheBuster({ cacheBusterNotifier: RegistreService.cacheBuster$ })
  delete_organization_document_to_company(id) {
    return this.http
      .post<any>(
        this.serverUrl +
        'registre/delete_organization_document_to_company/' +
        id,
        this.httpOptions
      )
      .pipe(catchError(this.handleError));
  }
  //@CacheBuster({ cacheBusterNotifier: RegistreService.cacheBuster$ })
  delete_investor_organization_document_to_company(id) {
    return this.http
      .post<any>(
        this.serverUrl +
        'registre/delete_investor_organization_document_to_company/' +
        id,
        this.httpOptions
      )
      .pipe(catchError(this.handleError));
  }
  //@CacheBuster({ cacheBusterNotifier: RegistreService.cacheBuster$ })
  delete_organization_contact_document_to_company(id) {
    return this.http
      .post<any>(
        this.serverUrl +
        'registre/delete_organization_contact_document_to_company/' +
        id,
        this.httpOptions
      )
      .pipe(catchError(this.handleError));
  }
  //@CacheBuster({ cacheBusterNotifier: RegistreService.cacheBuster$ })
  delete_investor_organization_contact_document_to_company(id) {
    return this.http
      .post<any>(
        this.serverUrl +
        'registre/delete_investor_organization_contact_document_to_company/' +
        id,
        this.httpOptions
      )
      .pipe(catchError(this.handleError));
  }
  //@Cacheable({ cacheBusterObserver: RegistreService.cacheBuster$ })
  deletedrawdown(id) {
    return this.http
      .get<any>(
        this.serverUrl + 'registre/deletedrawdown/' + id,
        this.httpOptions
      )
      .pipe(catchError(this.handleError));
  }
  //@Cacheable({ cacheBusterObserver: RegistreService.cacheBuster$ })
  deletepayment(slugpayment) {
    return this.http
      .get<any>(
        this.serverUrl + 'registre/deletepayment/' + slugpayment,
        this.httpOptions
      )
      .pipe(catchError(this.handleError));
  }

  //@Cacheable({ cacheBusterObserver: RegistreService.cacheBuster$ })
  deletecommitmentfees(slugpayment) {
    return this.http
      .get<any>(
        this.serverUrl + 'registre/deletecommitmentfees/' + slugpayment,
        this.httpOptions
      )
      .pipe(catchError(this.handleError));
  }

  //@CacheBuster({ cacheBusterNotifier: RegistreService.cacheBuster$ })
  update_drawdown_information_detail_for_fees(
    transactionprincipalpost: any
  ) {
    return this.http
      .post<any>(
        this.serverUrl + 'registre/update_drawdown_information_detail_for_fees',
        transactionprincipalpost,
        this.httpOptions
      )
      .pipe(catchError(this.handleError));
  }

  //@CacheBuster({ cacheBusterNotifier: RegistreService.cacheBuster$ })
  update_drawdown_info_for_fees(
    transactionprincipalpost: any
  ) {
    return this.http
      .post<any>(
        this.serverUrl + 'registre/update_drawdown_info_for_fees',
        transactionprincipalpost,
        this.httpOptions
      )
      .pipe(catchError(this.handleError));
  }
  //@CacheBuster({ cacheBusterNotifier: RegistreService.cacheBuster$ })
  update_commitment_fee_details(linkregistrepost: any) {
    return this.http
      .post<any>(
        this.serverUrl + 'registre/update_commitment_fee_details',
        linkregistrepost,
        this.httpOptions
      )
      .pipe(catchError(this.handleError));
  }

  //@CacheBuster({ cacheBusterNotifier: RegistreService.cacheBuster$ })
  update_lender_by_slug(slug, linkregistrepost: any) {
    return this.http
      .post<any>(
        this.serverUrl + 'registre/update_lender_by_slug/' + slug,
        linkregistrepost,
        this.httpOptions
      )
      .pipe(catchError(this.handleError));
  }
  //@CacheBuster({ cacheBusterNotifier: RegistreService.cacheBuster$ })
  update_payment(slug, linkregistrepost: any) {
    return this.http
      .post<any>(
        this.serverUrl + 'registre/update_payment/' + slug,
        linkregistrepost,
        this.httpOptions
      )
      .pipe(catchError(this.handleError));
  }
  //@CacheBuster({ cacheBusterNotifier: RegistreService.cacheBuster$ })
  update_transaction_principal(
    slug,
    linkregistrepost: any
  ) {
    return this.http
      .post<any>(
        this.serverUrl + 'registre/update_transaction_principal/' + slug,
        linkregistrepost,
        this.httpOptions
      )
      .pipe(catchError(this.handleError));
  }
  //@CacheBuster({ cacheBusterNotifier: RegistreService.cacheBuster$ })
  update_payment_control(linkregistrepost: any) {
    return this.http
      .post<any>(
        this.serverUrl + 'registre/update_payment_control',
        linkregistrepost,
        this.httpOptions
      )
      .pipe(catchError(this.handleError));
  }
  //@CacheBuster({ cacheBusterNotifier: RegistreService.cacheBuster$ })
  update_lot_notice(noticelotpost: any, slug) {
    return this.http
      .post<any>(
        this.serverUrl + 'registre/update_lot_notice/' + slug,
        noticelotpost,
        this.httpOptions
      )
      .pipe(catchError(this.handleError));
  }
  //@CacheBuster({ cacheBusterNotifier: RegistreService.cacheBuster$ })
  update_notice_history(noticehistorypost: any, slug) {
    return this.http
      .post<any>(
        this.serverUrl + 'registre/update_notice_history/' + slug,
        noticehistorypost,
        this.httpOptions
      )
      .pipe(catchError(this.handleError));
  }

  //@CacheBuster({ cacheBusterNotifier: RegistreService.cacheBuster$ })
  validate_generate_lot_notice(noticelotpost: any) {
    return this.http
      .post<any>(
        this.serverUrl + 'registre/validate_generate_lot_notice',
        noticelotpost,
        this.httpOptions
      )
      .pipe(catchError(this.handleError));
  }
  //@CacheBuster({ cacheBusterNotifier: RegistreService.cacheBuster$ })
  add_notice_contact_relation(
    noticecontactrelationpost: any
  ) {
    return this.http
      .post<any>(
        this.serverUrl + 'registre/add_notice_contact_relation',
        noticecontactrelationpost,
        this.httpOptions
      )
      .pipe(catchError(this.handleError));
  }
  //@CacheBuster({ cacheBusterNotifier: RegistreService.cacheBuster$ })
  sendnoticetoinvestors(sendnoticetoinvestorpost: any) {
    return this.http
      .post<any>(
        this.serverUrl + 'registre/sendnoticetoinvestors',
        sendnoticetoinvestorpost,
        this.httpOptions
      )
      .pipe(catchError(this.handleError));
  }

  generate_notice_by_deal(generatenoticepost: any) {
    // Ajouter un nouvel objet d'options pour spécifier la réponse attendue comme un blob
    const options = {
      headers: this.httpOptions.headers,
      responseType: 'blob' as 'json', // Forcer TypeScript à accepter 'blob' comme type de réponse
    };

    return this.http
      .post<Blob>(
        this.serverUrl + 'registre/generate_notice_by_deal',
        generatenoticepost,
        options
      )
      .pipe(catchError(this.handleError));
  }

  get_notice_by_deal(generatenoticepost: any) {
    return this.http
      .post<any>(
        this.serverUrl + 'registre/get_notice_by_deal',
        generatenoticepost,
        this.httpOptions
      )
      .pipe(catchError(this.handleError));
  }

  generate_notice_by_lot(generatenoticepost: any) {
    return this.http
      .post<any>(
        this.serverUrl + 'registre/generate_notice_by_lot',
        generatenoticepost,
        this.httpOptions
      )
      .pipe(catchError(this.handleError));
  }

  generate_notice_by_One(generatenoticepost: any) {
    return this.http
      .post<any>(
        this.serverUrl + 'registre/generate_notice_by_One',
        generatenoticepost,
        this.httpOptions
      )
      .pipe(catchError(this.handleError));
  }

  generate_all_notice_by_deal(generatenoticepost: any) {
    return this.http
      .post<any>(
        this.serverUrl + 'registre/generate_all_notice_by_deal',
        generatenoticepost,
        this.httpOptions
      )
      .pipe(catchError(this.handleError));
  }

  generate_all_notice_drawdown(data: any) {
    return this.http
      .post<any>(
        this.serverUrl + 'registre/generate_all_notice_drawdown',
        data,
        this.httpOptions
      )
      .pipe(catchError(this.handleError));
  }

  generate_notice_toggle(generatenoticepost: any) {
    // Ajouter un nouvel objet d'options pour spécifier la réponse attendue comme un blob
    const options = {
      headers: this.httpOptions.headers,
      responseType: 'blob' as 'json', // Forcer TypeScript à accepter 'blob' comme type de réponse
    };

    return this.http
      .post<Blob>(
        this.serverUrl + 'registre/download_notice_toggle',
        generatenoticepost,
        options
      )
      .pipe(catchError(this.handleError));
  }

  generate_all_notice_toggle(data: any) {
    return this.http
      .post<any>(
        this.serverUrl + 'registre/download_all_notice_toggle',
        data,
        this.httpOptions
      )
      .pipe(catchError(this.handleError));
  }

  generate_notice_by_deal_multiple(generatenoticepost: any) {
    // Ajouter un nouvel objet d'options pour spécifier la réponse attendue comme un blob
    const options = {
      headers: this.httpOptions.headers,
      responseType: 'blob' as 'json', // Forcer TypeScript à accepter 'blob' comme type de réponse
    };

    return this.http
      .post<Blob>(
        this.serverUrl + 'registre/generate_notice_by_deal_multiple',
        generatenoticepost,
        options
      )
      .pipe(catchError(this.handleError));
  }

  generate_notice_drawdown(generatenoticepost: any) {
    // Ajouter un nouvel objet d'options pour spécifier la réponse attendue comme un blob
    const options = {
      headers: this.httpOptions.headers,
      responseType: 'blob' as 'json', // Forcer TypeScript à accepter 'blob' comme type de réponse
    };

    return this.http
      .post<Blob>(
        this.serverUrl + 'registre/generate_notice_drawdown',
        generatenoticepost,
        options
      )
      .pipe(catchError(this.handleError));
  }

  //@CacheBuster({ cacheBusterNotifier: RegistreService.cacheBuster$ })
  update_legal_document_to_company(formData) {
    return this.http
      .post<any>(
        this.serverUrl + 'registre/update_legal_document_to_company',
        formData,
        {
          reportProgress: true,
          observe: 'events',
        }
      )
      .pipe(
        map(event => this.getEventMessage(event, formData)),
        catchError(this.handleError)
      );
  }

  //@CacheBuster({ cacheBusterNotifier: RegistreService.cacheBuster$ })
  update_investor_legal_document_to_company(formData) {
    return this.http
      .post<any>(
        this.serverUrl + 'registre/update_investor_legal_document_to_company',
        formData,
        {
          reportProgress: true,
          observe: 'events',
        }
      )
      .pipe(
        map(event => this.getEventMessage(event, formData)),
        catchError(this.handleError)
      );
  }
  //@CacheBuster({ cacheBusterNotifier: RegistreService.cacheBuster$ })
  update_organization_document_to_company(formData) {
    return this.http
      .post<any>(
        this.serverUrl + 'registre/update_organization_document_to_company',
        formData,
        {
          reportProgress: true,
          observe: 'events',
        }
      )
      .pipe(
        map(event => this.getEventMessage(event, formData)),
        catchError(this.handleError)
      );
  }
  //@CacheBuster({ cacheBusterNotifier: RegistreService.cacheBuster$ })
  update_investor_organization_document_to_company(formData) {
    return this.http
      .post<any>(
        this.serverUrl +
        'registre/update_investor_organization_document_to_company',
        formData,
        {
          reportProgress: true,
          observe: 'events',
        }
      )
      .pipe(
        map(event => this.getEventMessage(event, formData)),
        catchError(this.handleError)
      );
  }
  //@CacheBuster({ cacheBusterNotifier: RegistreService.cacheBuster$ })
  update_organization_contact_document_to_company(formData) {
    return this.http
      .post<any>(
        this.serverUrl +
        'registre/update_organization_contact_document_to_company',
        formData,
        {
          reportProgress: true,
          observe: 'events',
        }
      )
      .pipe(
        map(event => this.getEventMessage(event, formData)),
        catchError(this.handleError)
      );
  }
  //@CacheBuster({ cacheBusterNotifier: RegistreService.cacheBuster$ })
  update_investor_organization_contact_document_to_company(formData) {
    return this.http
      .post<any>(
        this.serverUrl +
        'registre/update_investor_organization_contact_document_to_company',
        formData,
        {
          reportProgress: true,
          observe: 'events',
        }
      )
      .pipe(
        map(event => this.getEventMessage(event, formData)),
        catchError(this.handleError)
      );
  }

  private getEventMessage(event: HttpEvent<any>, formData) {
    switch (event.type) {
      case HttpEventType.UploadProgress:
        return this.fileUploadProgress(event);
        break;
      case HttpEventType.Response:
        return this.apiResponse(event);
        break;
      default:
        return `File surprising upload event: ${event.type}.`;
    }
  }

  private fileUploadProgress(event) {
    const percentDone = Math.round((100 * event.loaded) / event.total);
    return { status: 'progress', message: percentDone };
  }

  private apiResponse(event) {
    return event.body;
  }

  //@Cacheable({ cacheBusterObserver: RegistreService.cacheBuster$ })
  get_all_organization_document_of_company(company) {
    return this.http
      .get<
        []
      >(this.serverUrl + 'registre/get_all_organization_document_of_company/' + company, this.httpOptions)
      .pipe(catchError(this.handleError));
  }

  //@Cacheable({ cacheBusterObserver: RegistreService.cacheBuster$ })
  get_all_investor_organization_document_of_company(company) {
    return this.http
      .get<
        []
      >(this.serverUrl + 'registre/get_all_investor_organization_document_of_company/' + company, this.httpOptions)
      .pipe(catchError(this.handleError));
  }

  //@Cacheable({ cacheBusterObserver: RegistreService.cacheBuster$ })
  get_all_organization_contact_document_of_company(company) {
    return this.http
      .get<
        []
      >(this.serverUrl + 'registre/get_all_organization_contact_document_of_company/' + company, this.httpOptions)
      .pipe(catchError(this.handleError));
  }
  //@Cacheable({ cacheBusterObserver: RegistreService.cacheBuster$ })
  get_detail_of_company_kyc(company) {
    return this.http
      .get<
        []
      >(this.serverUrl + 'registre/get_detail_of_company_kyc/' + company, this.httpOptions)
      .pipe(catchError(this.handleError));
  }
  //@Cacheable({ cacheBusterObserver: RegistreService.cacheBuster$ })
  get_detail_of_company_kyc_on_apscan_live(user, company) {
    return this.http
      .get<
        []
      >(this.serverUrl + 'registre/get_detail_of_company_kyc_on_apscan_live/' + user + '/' + company, this.httpOptions)
      .pipe(catchError(this.handleError));
  }
  //@Cacheable({ cacheBusterObserver: RegistreService.cacheBuster$ })
  get_detail_of_lender_kyc(company) {
    return this.http
      .get<
        []
      >(this.serverUrl + 'registre/get_detail_of_lender_kyc/' + company, this.httpOptions)
      .pipe(catchError(this.handleError));
  }
  //@Cacheable({ cacheBusterObserver: RegistreService.cacheBuster$ })
  get_organization_contact_document_of_company_by_slug(company, contact) {
    return this.http
      .get<
        []
      >(this.serverUrl + 'registre/get_organization_contact_document_of_company_by_slug/' + company + '/' + contact, this.httpOptions)
      .pipe(catchError(this.handleError));
  }

  //@Cacheable({ cacheBusterObserver: RegistreService.cacheBuster$ })
  get_all_investor_organization_contact_document_of_company(company) {
    return this.http
      .get<
        []
      >(this.serverUrl + 'registre/get_all_investor_organization_contact_document_of_company/' + company, this.httpOptions)
      .pipe(catchError(this.handleError));
  }

  //@CacheBuster({ cacheBusterNotifier: RegistreService.cacheBuster$ })
  add_legal_document_to_investor(
    investorlegaldocument: any
  ) {
    return this.http
      .post<any>(
        this.serverUrl + 'registre/add_legal_document_to_investor',
        investorlegaldocument,
        this.httpOptions
      )
      .pipe(catchError(this.handleError));
  }

  //@CacheBuster({ cacheBusterNotifier: RegistreService.cacheBuster$ })
  add_organization_document_to_investor(
    investororganizationdocumentpost: any
  ) {
    return this.http
      .post<any>(
        this.serverUrl + 'registre/add_organization_document_to_investor',
        investororganizationdocumentpost,
        this.httpOptions
      )
      .pipe(catchError(this.handleError));
  }

  //@CacheBuster({ cacheBusterNotifier: RegistreService.cacheBuster$ })
  add_payment(paymentpost: any) {
    //const currentUser = JSON.parse(localStorage.getItem('currentUser') || '{}');
    const currentUser = this.authService.currentUser();
    const group = currentUser.group;
    const slug_user = currentUser.username;

    const request = { ...paymentpost, slug_user: slug_user };

    return this.http
      .post<any>(
        this.serverUrl + 'registre/add_payment',
        request,
        this.httpOptions
      )
      .pipe(catchError(this.handleError));
  }

  //@CacheBuster({ cacheBusterNotifier: RegistreService.cacheBuster$ })
  add_commitmentfees(paymentpost: any) {
    return this.http
      .post<any>(
        this.serverUrl + 'registre/add_commitmentfees',
        paymentpost,
        this.httpOptions
      )
      .pipe(catchError(this.handleError));
  }
  //@CacheBuster({ cacheBusterNotifier: RegistreService.cacheBuster$ })
  add_cash_interest_period(cashinterestperiodpost: any) {
    return this.http
      .post<any>(
        this.serverUrl + 'registre/add_cash_interest_period',
        cashinterestperiodpost,
        this.httpOptions
      )
      .pipe(catchError(this.handleError));
  }
  //@CacheBuster({ cacheBusterNotifier: RegistreService.cacheBuster$ })
  add_commitmentfees_period(
    commitmentfeesperiodpost: any
  ) {
    return this.http
      .post<any>(
        this.serverUrl + 'registre/add_commitmentfees_period',
        commitmentfeesperiodpost,
        this.httpOptions
      )
      .pipe(catchError(this.handleError));
  }
  //@CacheBuster({ cacheBusterNotifier: RegistreService.cacheBuster$ })
  add_pik_interest_period(cashinterestperiodpost: any) {
    return this.http
      .post<any>(
        this.serverUrl + 'registre/add_pik_interest_period',
        cashinterestperiodpost,
        this.httpOptions
      )
      .pipe(catchError(this.handleError));
  }

  //@CacheBuster({ cacheBusterNotifier: RegistreService.cacheBuster$ })
  add_cash_interest_details(cashinterestpaymentpost: any) {
    return this.http
      .post<any>(
        this.serverUrl + 'registre/add_cash_interest_details',
        cashinterestpaymentpost,
        this.httpOptions
      )
      .pipe(catchError(this.handleError));
  }

  //@CacheBuster({ cacheBusterNotifier: RegistreService.cacheBuster$ })
  add_commitmentfees_details(
    commitmentfeespaymentpost: any
  ) {
    return this.http
      .post<any>(
        this.serverUrl + 'registre/add_commitmentfees_details',
        commitmentfeespaymentpost,
        this.httpOptions
      )
      .pipe(catchError(this.handleError));
  }
  //@CacheBuster({ cacheBusterNotifier: RegistreService.cacheBuster$ })
  add_pik_interest_details(cashinterestpaymentpost: any) {
    return this.http
      .post<any>(
        this.serverUrl + 'registre/add_pik_interest_details',
        cashinterestpaymentpost,
        this.httpOptions
      )
      .pipe(catchError(this.handleError));
  }
  //@Cacheable({ cacheBusterObserver: RegistreService.cacheBuster$ })
  get_total_payment_data_by_deal_tranche(deal, tranche) {
    return this.http
      .get<
        any
      >(this.serverUrl + 'registre/get_total_payment_data_by_deal_tranche/' + deal + '/' + tranche, this.httpOptions)
      .pipe(catchError(this.handleError));
  }
  //@Cacheable({ cacheBusterObserver: RegistreService.cacheBuster$ })
  get_drawdown_total_amount(tranche) {
    return this.http
      .get<
        any
      >(this.serverUrl + 'registre/get_drawdown_total_amount/' + tranche, this.httpOptions)
      .pipe(catchError(this.handleError));
  }
  //@Cacheable({ cacheBusterObserver: RegistreService.cacheBuster$ })
  get_mouvement_detail(slug) {
    return this.http
      .get<
        any
      >(this.serverUrl + 'registre/get_mouvement_detail/' + slug, this.httpOptions)
      .pipe(catchError(this.handleError));
  }
  //@Cacheable({ cacheBusterObserver: RegistreService.cacheBuster$ })
  get_all_mouvement() {
    return this.http
      .get<[]>(this.serverUrl + 'registre/get_all_mouvement', this.httpOptions)
      .pipe(catchError(this.handleError));
  }
  //@Cacheable({ cacheBusterObserver: RegistreService.cacheBuster$ })
  get_all_mouvement_by_tranche(slug) {
    return this.http
      .get<
        []
      >(this.serverUrl + 'registre/get_all_mouvement_by_tranche/' + slug, this.httpOptions)
      .pipe(catchError(this.handleError));
  }

  //@CacheBuster({ cacheBusterNotifier: RegistreService.cacheBuster$ })
  add_new_mouvement(mouvementpost: any) {
    return this.http
      .post<any>(
        this.serverUrl + 'registre/add_new_mouvement',
        mouvementpost,
        this.httpOptions
      )
      .pipe(catchError(this.handleError));
  }
    // Removed 2026-09-17: update_trade_file() — registre/update_trade_file was deleted (wrote to assets/trade/, no component called it).

  //@CacheBuster({ cacheBusterNotifier: RegistreService.cacheBuster$ })
  add_notice_comment(
    slug_deal,
    slug_tranche,
    slug_payment,
    slug_investor,
    noticecommentpost: any
  ) {
    return this.http
      .post<any>(
        this.serverUrl +
        'local/create_notice_by_investor_by_payment' +
        slug_deal +
        '/' +
        slug_tranche +
        slug_payment +
        '/' +
        slug_investor,
        noticecommentpost,
        this.httpOptions
      )
      .pipe(catchError(this.handleError));
  }

  //@Cacheable({ cacheBusterObserver: RegistreService.cacheBuster$ })
  get_all_notice_lot_by_deal(id) {
    return this.http
      .get<
        []
      >(this.serverUrl + 'registre/get_all_notice_lot_by_deal/' + id, this.httpOptions)
      .pipe(catchError(this.handleError));
  }

  //@Cacheable({ cacheBusterObserver: RegistreService.cacheBuster$ })
  get_all_payment(day) {
    return this.http
      .get<any>(
        this.serverUrl + 'registre/get_all_payment/' + day,
        this.httpOptions
      )
      .pipe(catchError(this.handleError));
  }

  // ******** Réactivité avec les signals *************

  private isLoadingSignal = signal<boolean>(false);

  getStatus() {
    return this.isLoadingSignal.asReadonly();
  }

  // LES LENDERS
  private lendersSignal = signal<any[]>([]);

  getAllLendersSignal() {
    return this.lendersSignal.asReadonly();
  }

  add_new_lender__(registrepost: any) {
    this.isLoadingSignal.set(true);
    this.http
      .post<any>(
        this.serverUrl + 'registre/add_registre_bearer',
        registrepost,
        this.httpOptions
      )
      .pipe(catchError(this.handleError))
      .subscribe({
        next: lender => {
          this.lendersSignal.update(lenders => [lender['data'], ...lenders]);
          this.isLoadingSignal.set(false);
        },
        error: error => {
        },
      });
  }

  add_new_lender(registrepost: any) {
    return this.http
      .post<any>(
        this.serverUrl + 'registre/add_registre_bearer',
        registrepost,
        this.httpOptions
      )
      .pipe(catchError(this.handleError));
  }

  get_all_lenders() {
    this.isLoadingSignal.set(true);
    this.http
      .get<[]>(this.serverUrl + 'registre/get_all_lenders', this.httpOptions)
      .pipe(catchError(this.handleError))
      .subscribe(lenders => {
        this.lendersSignal.set(lenders);
        this.isLoadingSignal.set(false);
      });
  }

  // Méthode qui retourne un Observable pour récupérer les lenders
  getAllLenders(): Observable<any[]> {
    return this.http
      .get<any[]>(this.serverUrl + 'registre/get_all_lenders', this.httpOptions)
      .pipe(catchError(this.handleError));
  }

  /**
   * Récupère les lenders avec pagination serveur pour améliorer les performances
   * @param pageIndex Index de la page (0-based)
   * @param pageSize Nombre d'éléments par page
   */
  getAllLendersPaginated(
    pageIndex: number,
    pageSize: number,
    sortBy: string = 'id',
    sortDir: string = 'DESC',
    country: string = ''
  ): Observable<{ data: any[]; total: number }> {
    let params = new HttpParams()
      .set('page', pageIndex.toString())
      .set('limit', pageSize.toString())
      .set('sort_by', sortBy)
      .set('sort_dir', sortDir);
    const c = (country ?? '').trim();
    if (c) {
      params = params.set('country', c);
    }

    return this.http
      .get<{ data: any[]; total: number }>(
        this.serverUrl + 'registre/get_all_lenders_paginated',
        { ...this.httpOptions, params }
      )
      .pipe(catchError(this.handleError));
  }

  getDeletedLendersPaginated(
    pageIndex: number,
    pageSize: number,
    sortBy: string = 'deleted_at',
    sortDir: string = 'DESC'
  ): Observable<{ data: any[]; total: number }> {
    const params = new HttpParams()
      .set('page', pageIndex.toString())
      .set('limit', pageSize.toString())
      .set('sort_by', sortBy)
      .set('sort_dir', sortDir);

    return this.http
      .get<{ data: any[]; total: number }>(
        this.serverUrl + 'registre/get_deleted_lenders_paginated',
        { ...this.httpOptions, params }
      )
      .pipe(catchError(this.handleError));
  }

  get_lender_deletion_check(lenderId: number) {
    return this.http
      .get<any>(this.serverUrl + 'registre/get_lender_deletion_check/' + lenderId, this.httpOptions)
      .pipe(catchError(this.handleError));
  }

  delete_lender(lenderId: number, payload: { reason: string; lender_name?: string; url?: string }) {
    return this.http
      .post<any>(this.serverUrl + 'registre/delete_lender/' + lenderId, payload, this.httpOptions)
      .pipe(catchError(this.handleError));
  }

  // ******** Réactivité avec les signals *************

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      console.error('An error occurred:', error.error.message);
    } else {
      console.error(
        `Backend returned code ${error.status}, ` + `body was: ${error.message}`
      );
    }
    // Pass through the full error so components can access error.error?.message (e.g. from API JSON response)
    const message = error?.error?.message || error?.message || 'Something bad happened. Please try again later.';
    return throwError(() => ({ ...error, displayMessage: message }));
  }
}
